<script lang="ts">
  import { useProsemirrorAdapterProvider } from '@prosemirror-adapter/svelte';
  import MarkdownEditor from './MarkdownEditor.svelte';
  import type { FileUpload } from '../../firebase/common/feed';

  useProsemirrorAdapterProvider();

  export let content: string;
  export let freeToRead: string | null = null;
  export let readingText: string | null = null;
  export let readonly: boolean = false;
  export let label: string | null = null;
  export let images: FileUpload[] = [];
</script>

<MarkdownEditor bind:content bind:freeToRead bind:readingText bind:readonly bind:label bind:images />
